<template>
  <my-dialog
    diaWidth="60%"
    dialogTitle="添加员工"
    :isShowDialog="isShowDialog"
    @handleCloseDia="handleCloseDia"
    @diaCancelBtn="handleCloseDia"
    @diaConfirmBtn="diaConfirmBtn"
    isAppend
  >
    <!-- 综合查询 -->
    <page
      ref="pageDemo"
      number="admin_employee_list"
      :conditionsC="paramOne"
      v-if="isShowDialog"
    ></page>
  </my-dialog>
</template>
<script>
import MyDialog from "@/components/Dialog.vue";
import Page from "@/components/Page.vue";
import customerComponent from "@/assets/js/Mixins/CustomerComponent";
export default {
  mixins: [customerComponent],
  props: {
    value: {
      type: Array,
      require: false,
      default() {
        return [];
      },
    },
    show: {
      type: Boolean,
      require: false,
      default() {
        return false;
      },
    },
    paramOne: {
      type: Object,
      require: false,
      default() {
        return {};
      },
    },
  },
  components: {
    MyDialog,
    Page,
  },
  data() {
    return {
      isShowDialog: this.show,
    };
  },
  updated() {},
  created() {},
  mounted() {},
  activated() {},

  watch: {
    show(val) {
      this.isShowDialog = val;
    },
  },
  methods: {
    handleCloseDia() {
      this.$emit("update:show", false);
    },
    diaConfirmBtn() {
      const rows = this.$refs.pageDemo.rows();
      this.$emit("input", rows);
      this.$emit("change", rows);
      this.$emit("update:show", false);
      this.feedback(rows);
    },
  },
};
</script>


<style scoped lang="less">
.container {
  height: calc(100vh - 80px);
  overflow: hidden;
  display: flex;
  flex-flow: column;
}
.emp-condition {
  /deep/ .el-form {
    span {
      margin-right: 10px;
    }
  }
  /deep/ .el-form-item__label {
    margin-top: 0 !important;
  }
}
</style>
